import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AutoSizeDirective } from './auto-size.directive';
import { CepDirective } from './cep.directive';
import { CpfCnpjDirective } from './cpf-cnpj.directive';
import { DigitOnlyDirective } from './digit-only.directive';
import { FocusDirective } from './focus.directive';
import { OnlyNumbersDirective } from './only-numbers.directive';
import { PatientSearchDirective } from './patient-search.directive';
import { TelephoneDirective } from './telephone.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    CpfCnpjDirective,
    TelephoneDirective,
    AutoSizeDirective,
    FocusDirective,
    PatientSearchDirective,
    CepDirective,
    DigitOnlyDirective,
    OnlyNumbersDirective
  ],
  exports: [
    CpfCnpjDirective,
    TelephoneDirective,
    AutoSizeDirective,
    FocusDirective,
    PatientSearchDirective,
    CepDirective,
    DigitOnlyDirective,
    OnlyNumbersDirective
  ]
})
export class DirectivesModule {}
